import { Component, Inject, OnInit } from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-filer-overlay',
  standalone: false,
  templateUrl: './filer-overlay.component.html',
  styleUrl: './filer-overlay.component.scss'
})
export class FilerOverlayComponent implements OnInit{

  listArr:any;
  sortingDirection: 'ASC' | 'DESC' = 'ASC';
  allSelected:boolean = true;
  sortColumn:string = "name";
  userData: any;

  constructor(public dialogRef: MatDialogRef<FilerOverlayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpSerive:HttpService) { 
      dialogRef.disableClose = true;
      let tempArr:any=this.data.value;
      this.listArr = tempArr.filter((item:any)=>item.orderId !== 0)
      .sort((a:any, b:any) => a.orderId - b.orderId);
      this.allSelected = this.listArr.every((item:any) => item.selected);
  }

  ngOnInit(): void {
    let userData = sessionStorage.getItem("user-data");
    this.userData = userData?JSON.parse(userData):null;
  }

  drop(event: CdkDragDrop<string[]>|any) {
    moveItemInArray(this.listArr, event.previousIndex, event.currentIndex);    
  }

  onCloseBtn(){
    this.dialogRef.close({ operation: 'close' });
  }

  onSaveBtn(){
    this.listArr.forEach((element:any, i:number)=>element.orderId = i+1);
    let updateArr:any =[]
    this.listArr.map((i:any)=>{
      let data = {
        UserID:this.userData.UserID, 
        ScreenColumnName: i.name, 
        ScreenColumnOrderNo:i.orderId, 
        IsActive:i.selected,
        ScreenID: i.ScreenID,				
        ScreenColumnID:i.ScreenColumnID
      };
      updateArr.push(data);
    })

    this.httpSerive.updatecolumnList(updateArr)
    .subscribe((res: any) => {
      if (res) {
        this.httpSerive.openSnackBar("Column list updated successfully");
        this.dialogRef.close({ operation: 'save' });
      }
    })
  }

  selectAll() {
    this.allSelected = !this.allSelected;
    this.listArr.forEach((item: any) => {
      item.selected = this.allSelected;
    });
  }

  selectItem(name:any) {
    this.listArr.find((item:any)=>{
      if(item.name == name){
        item.selected = !item.selected
      }
    });
    this.allSelected = this.listArr.every((item:any) => item.selected);
  }

  onSortingColumns(){
    if (this.sortingDirection === 'ASC') {
      this.listArr.sort((a:any, b:any) => a.name.localeCompare(b.name));
      this.sortingDirection = 'DESC';
    } else {
      this.listArr.sort((a:any, b:any) => a.name.localeCompare(b.name)).reverse();
      this.sortingDirection = 'ASC';
    }
  }

  
}
